import type React from 'react';
import type {
  ConversationMessageDataType,
  ConversationUserType,
} from '../../../../redux/ducks/ChatDucks.types';

export type TextMessageProps = {
  mine?: boolean;
  data: ConversationMessageDataType;
  user?: ConversationUserType;
};

const TextMessage: React.FC<TextMessageProps> = ({ mine, data, user }) => (
  <span className="flex flex-col">
    {!mine && user && (
      <span className="-mt-2 mb-1 font-semibold">{`${user.first_name} ${user.last_name}`}</span>
    )}
    <span>{data?.text || ''}</span>
  </span>
);

export default TextMessage;
